import { shopDeleteApi } from "../../api/shop/shopDeleteApi"

type PayloadShape = Parameters<typeof shopDeleteApi>[0]

export async function shopDeleteService(payload: PayloadShape, token: string) {
	return await shopDeleteApi(payload, token)
}
